import { faCalendarDay } from "@fortawesome/free-solid-svg-icons/faCalendarDay";
import { faCircleMinus } from "@fortawesome/free-solid-svg-icons/faCircleMinus";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import { faPencil } from "@fortawesome/free-solid-svg-icons/faPencil";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons/faToggleOn";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons/faXmarkCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IColuna } from "app/types/IColuna"
import { Vendedor } from "app/types/Vendedor"
import { DadosDaPesquisaOrcamento, DadosPesquisaOrcamento, DadosTotalDaPesquisaOrcamento, FiltroPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento"
import clsx from "clsx"
import { FormikErrors, useFormik } from "formik"
import globalMU from "globalMU"
import indexOf from "lodash/indexOf";
import sortBy from "lodash/sortBy";
import * as R from 'ramda'
import React, { memo, useCallback, useMemo, useState } from "react"
import { InputData } from "../inputs/InputData"
import Legenda from "../itens-orcamento/legenda/Legenda"
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao"
import { Separador } from "../separador/Separador"
import { AcoesHeadPesquisaOrcamento } from "./table-head/AcoesHeadPesquisaOrcamento"
import { EstilosIndividuaisNomeColunasPesquiaOrcamento } from "./table-head/EstilosIndividuaisNomeColunasPesquiaOrcamento"
import HeadPesquisaOrcamento from "./table-head/HeadPesquisaOrcamento"
import { TooltipMU } from "../tooltip/TooltipMU"
//import { HeadPesquisaOrcamento } from "./table-head/HeadPesquisaOrcamento"

const estilosBotoes = require("../../estilos/botoes.module.scss").default;
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosTabelas = require('../../estilos/tabelas.module.scss').default
import { fonteGradeEmPxOuPadrao } from 'app/utils/tamanhoFonteGrid'

const _ORDENACAO_COLUNAS_PESQUISA_ORCAMENTO = [
    "DataPedido",
    "NumeroPedido",
    "Filial",
    "RazaoSocialCliente",
    "SituacaoMontagem",
    "SituacaoVenda",
    "Vendedor",
    "DataAtualizacao",
    "QtdeProdutos",
    "MarkupRealTotal",
    "PedidosDeCompra",
    "ValorPedido",
    "OrcamentosUnificados"
];

const _RENDERIZAR_CELULA_PESQUISA_ORCAMENTO: Record<string, (item: DadosDaPesquisaOrcamento) => React.ReactNode> = {
    DataPedido: (item) => globalMU.formatDate(item.DataPedido) + ' ' + globalMU.formatHourMinute(item.DataPedido),
    NumeroPedido: (item) => item.NumeroPedido.toString(),
    Filial: (item) => item.Filial,
    RazaoSocialCliente: (item) => item.RazaoSocialCliente,
    SituacaoMontagem: (item) => item.SituacaoMontagem,
    SituacaoVenda: (item) => item.DescricaoSituacaoVenda,
    Vendedor: (item) => item.Vendedor,
    DataAtualizacao: (item) => globalMU.formatDate(item.DataAtualizacao) + ' ' + globalMU.formatHourMinute(item.DataAtualizacao),
    QtdeProdutos: (item) => <div className={`_flex ${!item.PedidoAtendido && "_justify-between"}`}>
        {!item.PedidoAtendido && <FontAwesomeIcon className="_text-xl" color='#ff0000' icon={faExclamationTriangle} />}
        <p>{item.QtdeProdutos.toString()}</p>
    </div>,
    MarkupRealTotal: (item) => globalMU.formatNumber(item.MarkupRealTotal, 2),
    PedidosDeCompra: (item) => item.ListaPedidosCompra,
    ValorPedido: (item) => globalMU.formatMoney(item.ValorPedido),
    OrcamentosUnificados: (item) => item.OrcamentosUnificados,
}

const _RENDERIZAR_RODAPE_PESQUISA_ORCAMENTO: Record<string, (valorTotalOrcamentos: number) => React.ReactNode> = {
    DataPedido: () => "Total",
    ValorPedido: (valorTotalOrcamentos) => globalMU.formatMoney(valorTotalOrcamentos),
}

export type PesquisaOrcamentoProps = {
    processando?: boolean
    dadosPesquisaOrcamento: Partial<DadosPesquisaOrcamento>
    filtroPesquisaOrcamento: Partial<FiltroPesquisaOrcamento>
    vendedor: Partial<Vendedor>
    codigoFilialUsuarioLogado?: string // 476918
    colunas: IColuna[]
    dadosPesquisa: Partial<DadosTotalDaPesquisaOrcamento>
    tamanhoFontePadrao: number
    usuarioPedeSenhaACadaOrcamento: boolean
    habilitarDuplicacaoOrcamento: boolean
    permitirImprimirOrcamento: boolean
    permitirTrocarFilial: boolean
    permitirAlterarSemRecalcularPreco?: boolean // 455487
    permitirAlterarValidadeOrcamento?: boolean // 456674
    permiteEngrenagemGrid: boolean
    destacarPendenciaEstoqueConsultaOrcamento: boolean
    exibirOrcamentosUnificadosConsulta: boolean
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    corSelecionada: string
    textoSelecionado: string
    tableRef: React.MutableRefObject<undefined>
    exibirSituacaoConferencia: boolean
    onPesquisarCliente: (filtro: Partial<FiltroPesquisaOrcamento>) => void
    onLimparCliente: () => void
    onAlterarOrcamento: (semRecalcular: boolean) => void // 455487
    onDuplicarOrcamento: () => void
    onConsultarOrcamento: () => void
    onImprimirOrcamento: () => void
    onCancelarOrcamento: () => void
    onTrocarFilialOrcamento: () => void
    onAlterarValidadeOrcamento: () => void // 456674
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
    onAlterarFonte: (fonte: number) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
    onPesquisarPaginada: (filtro: Partial<FiltroPesquisaOrcamento>) => void;
    onPesquisar: (filtro: Partial<FiltroPesquisaOrcamento>) => void
    onSelecionarOrcamento: (orcamentoSelecionado: DadosDaPesquisaOrcamento) => void;
    onEditarUltimoOrcamento: () => void
    onErrorValidacao: (erros: FormikErrors<FiltroPesquisaOrcamento>) => void
    onMostrarJustificativaAlterar: (justificativa: string) => void
    onMostrarJustificativaDuplicar: (justificativa: string) => void
}

export const PesquisaOrcamento = memo((props: PesquisaOrcamentoProps) => {

    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [carregarOpcoesFilial, setCarregarOpcoesFilial] = useState<boolean>(false)
    const [carregarOpcoesVendedor, setCarregarOpcoesVendedor] = useState<boolean>(false)

    const formik = useFormik({
        initialValues: {
            ...props.filtroPesquisaOrcamento,
            DataFinal: props.filtroPesquisaOrcamento?.DataFinal ?? globalMU.converterObjetoDateParaDataFormatoEN(new Date()),
            DataInicial: props.filtroPesquisaOrcamento?.DataInicial ?? globalMU.converterObjetoDateParaDataFormatoEN(new Date()),
            CodigoFilial: props.filtroPesquisaOrcamento?.CodigoFilial ?? props.dadosPesquisaOrcamento?.Filiais?.find(i => i.Codigo == props.dadosPesquisaOrcamento.CodigoFilialDefaultUsuario)?.Codigo,
            CodigoVendedor: props.filtroPesquisaOrcamento?.CodigoVendedor != null ? props.filtroPesquisaOrcamento?.CodigoVendedor : !props.dadosPesquisaOrcamento?.VendedorLogado?.GerenciaOutrosVendedores ? props.dadosPesquisaOrcamento?.VendedorLogado?.Codigo : null
        },
        onSubmit: async (values) => {
            const erros = await formik.validateForm(values)
            Object.keys(erros).length == 0 ? props.onPesquisar(values) : props.onErrorValidacao(erros)
            setFormularioValidado(true);
        },
        enableReinitialize: true,
        validate: (values) => {
            const mensagemDataMenor = (campo1: string, campo2: string) => `O campo  "${campo1}" não pode ser maior do que a "${campo2}".`
            return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
                DataInicial: new Date(values.DataInicial).getTime() > new Date(values.DataFinal).getTime() ? mensagemDataMenor("Data Inicial", "Data Final") : undefined,
            } as FormikErrors<FiltroPesquisaOrcamento>)
        }
    });

    const filialSelecionada = useMemo(() => (
        props.dadosPesquisaOrcamento?.Filiais?.find((filial) => filial.Codigo == formik.values.CodigoFilial)
    ), [props.dadosPesquisaOrcamento?.Filiais, formik.values.CodigoFilial])

    const vendedorSelecionado = useMemo(() => (
        props.dadosPesquisaOrcamento?.Vendedores?.find((vendedor) => vendedor.CodigoVendedor == formik.values.CodigoVendedor)
    ), [props.dadosPesquisaOrcamento?.Vendedores, formik.values.CodigoVendedor])

    const opcoesFilial = useMemo(() => {
        if (carregarOpcoesFilial) {
            return props.dadosPesquisaOrcamento?.Filiais ?? []
        }

        return filialSelecionada != null ? [filialSelecionada] : []
    }, [carregarOpcoesFilial, props.dadosPesquisaOrcamento?.Filiais, filialSelecionada])

    const opcoesVendedor = useMemo(() => {
        if (carregarOpcoesVendedor) {
            return props.dadosPesquisaOrcamento?.Vendedores ?? []
        }

        return vendedorSelecionado != null ? [vendedorSelecionado] : []
    }, [carregarOpcoesVendedor, props.dadosPesquisaOrcamento?.Vendedores, vendedorSelecionado])
    
    const botoesAcaoTabela = useMemo(() => <>
                    <div className="_flex _my-3 _justify-start _items-start _flex-wrap">
                    <button
                        title="Veja parâmetro: Atualiza a data do orçamento na manutenção do orçamento?"
                        disabled={props.processando || !props.orcamentoSelecionado}
                        id="PesquisaOrcamento_botaoAlterar"
                        onClick={() => {
                            globalMU.isNullOrEmpty(formik.values.JustificativaAlterar) ? props.onAlterarOrcamento(false) : props.onMostrarJustificativaAlterar(formik.values.JustificativaAlterar)
                        }}
                        //className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                        className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                        >
                        <FontAwesomeIcon icon={faPencil}
                            className="_text-2xl _mx-1"
                        />
                        Alterar
                    </button>

                    {props.permitirAlterarSemRecalcularPreco && props.orcamentoSelecionado?.PermiteAlterarSemRecalcularPreco
                        && globalMU.isNullOrEmpty(formik.values.JustificativaAlterar) 
                    && // 455487
                        <button
                        disabled={props.processando || !props.orcamentoSelecionado || !globalMU.isNullOrEmpty(formik.values.JustificativaAlterar) || !props.orcamentoSelecionado?.PermiteAlterarSemRecalcularPreco  }
                        id="PesquisaOrcamento_botaoAlterarSemRecalcular"
                        onClick={() => {
                            props.onAlterarOrcamento(true)  // 455487
                        }}
                        //className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                        className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                        >
                        <FontAwesomeIcon icon={faFileInvoiceDollar}
                            className="_text-2xl _mx-1"
                        />
                        Alterar, Sem Recalcular Preços
                    </button>
                    }
                    {props.habilitarDuplicacaoOrcamento &&
                        <TooltipMU
                            key="Tooltip_PesquisaOrcamento_botaoDuplicar"
                            textAlign="left"
                            showTooltip={props.orcamentoSelecionado?.CodigoVendedor != props.vendedor?.Codigo || props.orcamentoSelecionado?.Filial != props.codigoFilialUsuarioLogado} // 476918
                            title={
                            <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                                <span style={{ color: 'gray', fontWeight: 'bold' }}>Pedido será alterado para:
                                </span>
                                    <br></br>Filial: {props.codigoFilialUsuarioLogado} 
                                    <br></br>Vendedor: {props.vendedor?.Codigo}
                            </div>
                            }
                        >
                        <span>
                        <button
                            disabled={props.processando || !props.orcamentoSelecionado}
                            id="PesquisaOrcamento_botaoDuplicar"
                            title="ATENÇÃO:&#013;A duplicação altera o vendedor e a filial do pedido para a filial do usuário!&#013;&#013;Veja parâmetros:&#013;-Habilitar duplicação de orçamento&#013;-Tipo de bloqueio para duplicação de orçamento"
                            onClick={() => {
                                globalMU.isNullOrEmpty(formik.values.JustificativaDuplicar) ? props.onDuplicarOrcamento() : props.onMostrarJustificativaDuplicar(formik.values.JustificativaDuplicar)
                            }}
                            //className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                            className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                            >
                            <FontAwesomeIcon icon={faCopy}
                                className="_text-2xl _mx-1"
                            />
                            Duplicar
                        </button>
                        </span>
                        </TooltipMU>
                    }
                    <button
                        disabled={props.processando || !props.orcamentoSelecionado}
                        id="PesquisaOrcamento_botaoConsultar"
                        onClick={() => props.onConsultarOrcamento()}
                        //</div>className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                        className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                        >
                        <FontAwesomeIcon icon={faSearch}
                            className="_text-2xl _mx-1"
                        />
                        Consultar
                    </button>
                    {props.permitirImprimirOrcamento &&
                        <button
                            disabled={props.processando || !props.orcamentoSelecionado}
                            title="Veja parâmetro:&#013;&#013;-Ordem de impressão dos itens no orçamento&#013;&#013;-Bloquear impressão de orçamento pendente&#013;-Solicitar senha de autorização na impressão de orçamentos com desconto acima do permitido&#013;-Recalcular preço de venda na alteração de orçamento vencido"
                            id="PesquisaOrcamento_botaoImprimir"
                            onClick={() => props.onImprimirOrcamento()}
                            //className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input  [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                            className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                            >
                            <FontAwesomeIcon icon={faPrint}
                                className="_text-2xl _mx-1"
                            />
                            Imprimir
                        </button>
                    }
                    {props.dadosPesquisaOrcamento?.VendedorLogado?.GerenciaOutrosVendedores &&
                    <button
                        disabled={props.processando || !props.orcamentoSelecionado}
                        id="PesquisaOrcamento_botaoCancelar"
                        onClick={() => props.onCancelarOrcamento()}
                        //</div>className="_flex _mx-3 _gap-x-2 no-global-button  no-global-input [&>svg]:_text-[#f25713] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                        className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                        >
                        <FontAwesomeIcon icon={faCircleMinus}
                            className="_text-2xl _mx-1"
                        />
                        Cancelar
                    </button>
                    }
                    {props.permitirTrocarFilial &&
                        <button
                            disabled={props.processando || !props.orcamentoSelecionado || !formik.values.PermiteTrocarFilial}
                            id="PesquisaOrcamento_botaoTrocarFilial"
                            onClick={() => props.onTrocarFilialOrcamento()}
                            //className="_flex _mx-3 _gap-x-2 no-global-button no-global-input [&>svg]:_text-[#3c8ac9] disabled:_text-[#bbb] [&>svg]:disabled:_text-[#bbb] _mt-2"
                            className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                            >
                            <FontAwesomeIcon icon={faToggleOn}
                                className="_text-2xl _mx-1 _text-[#3c8ac9] _cursor-pointer"
                            />
                            Trocar Filial
                        </button>
                    }

                    {props.permitirAlterarValidadeOrcamento  // 456674
                        && 
                        <button
                            disabled={props.processando || !props.orcamentoSelecionado
                                    || props.orcamentoSelecionado.CodigoSituacaoVenda === '2'
                                    || props.orcamentoSelecionado.CodigoSituacaoVenda === '3'
                                    || props.orcamentoSelecionado.CodigoSituacaoVenda === '4'
                                    || (!props.dadosPesquisaOrcamento?.VendedorLogado?.GerenciaOutrosVendedores && props.dadosPesquisaOrcamento?.VendedorLogado?.Codigo !== props.orcamentoSelecionado.CodigoVendedor )
                                }
                            id="PesquisaOrcamento_botaoAlterarValidadeOrcamento"
                            onClick={() => props.onAlterarValidadeOrcamento()}
                            className={clsx(estilosBotoes.botaoIcone,'no-global-button')}
                            >
                            <FontAwesomeIcon icon={faCalendarDay}
                                className="_text-2xl _mx-1 _text-[#3c8ac9] _cursor-pointer"
                            />
                            Alterar Validade
                        </button>
                    }

                </div>
    </>, [
        props.processando,
        props.orcamentoSelecionado,
        props.permitirAlterarSemRecalcularPreco,
        props.onAlterarOrcamento,
        props.onMostrarJustificativaAlterar,
        props.habilitarDuplicacaoOrcamento,
        props.vendedor?.Codigo,
        props.codigoFilialUsuarioLogado,
        props.onDuplicarOrcamento,
        props.onMostrarJustificativaDuplicar,
        props.onConsultarOrcamento,
        props.permitirImprimirOrcamento,
        props.onImprimirOrcamento,
        props.dadosPesquisaOrcamento?.VendedorLogado?.GerenciaOutrosVendedores,
        props.dadosPesquisaOrcamento?.VendedorLogado?.Codigo,
        props.onCancelarOrcamento,
        props.permitirTrocarFilial,
        props.onTrocarFilialOrcamento,
        props.permitirAlterarValidadeOrcamento,
        props.onAlterarValidadeOrcamento,
        formik.values.JustificativaAlterar,
        formik.values.JustificativaDuplicar,
        formik.values.PermiteTrocarFilial,
    ])

    const itensLegendas = useMemo(() => {
        const itens = [
            {
                nome: "Venda",
                cor: "var(--mu-azul-marcador, #0000FF)",
            },
            {
                nome: "Outras Saídas",
                cor: "#EC780F",
            },
            {
                nome: "Transferências",
                cor: "#00C800",
            },
        ];

        if (props.exibirOrcamentosUnificadosConsulta) {
            itens.push({
                nome: "Venda - Unificado",
                cor: "#FFFF00",
            });
        }

        return itens;
    }, [props.exibirOrcamentosUnificadosConsulta])

    const itensOrcamento = useCallback(({ nomeColuna, item }: { nomeColuna: string, item: DadosDaPesquisaOrcamento }) => {
        return <td
                    className="_table-cell"
                    style={EstilosIndividuaisNomeColunasPesquiaOrcamento({ nomeColuna: nomeColuna, header: false, item: item })}
                    key={`PesquisaOrcamento_Coluna_${nomeColuna}_${item.NumeroPedido}`}
                    id={`PesquisaOrcamento_Coluna_${nomeColuna}_${item.NumeroPedido}_${nomeColuna}`}
                >
                    {_RENDERIZAR_CELULA_PESQUISA_ORCAMENTO[nomeColuna]?.(item)}
                </td>
    }, [])

    const ocultarColunas = useMemo<{ [key: string]: boolean }>(() => ({
        "DataAtualizacao": !props.destacarPendenciaEstoqueConsultaOrcamento,
        "QtdeProdutos": !props.destacarPendenciaEstoqueConsultaOrcamento,
        "OrcamentosUnificados": !props.exibirOrcamentosUnificadosConsulta,
    }), [props.destacarPendenciaEstoqueConsultaOrcamento, props.exibirOrcamentosUnificadosConsulta])

    const itensOrcamentoFooter = useCallback(({ nomeColuna, valorTotalOrcamentos }: { nomeColuna: string, valorTotalOrcamentos: number }) => {
        return <th
                className="_table-cell"
                id={`PesquisaOrcamento_Footer_Coluna_${nomeColuna}`}
                key={`PesquisaOrcamento_Footer_Coluna_${nomeColuna}`}
                style={nomeColuna == "ValorPedido"
                    ? { textAlign: 'right' }
                    : {}}
                >
                    {_RENDERIZAR_RODAPE_PESQUISA_ORCAMENTO[nomeColuna]?.(valorTotalOrcamentos)}
                </th>
    }, [])

    const colunasOrdenadas = useMemo(() => {
        const filtradas = props.colunas?.filter(
            coluna => _ORDENACAO_COLUNAS_PESQUISA_ORCAMENTO.includes(coluna.Nome) && coluna.Permitido && !ocultarColunas[coluna.Nome]
        )
        return sortBy(filtradas, (coluna) => indexOf(_ORDENACAO_COLUNAS_PESQUISA_ORCAMENTO, coluna.Nome))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.colunas, ocultarColunas])

    return (
        <>
            <form
                id="PesquisaOrcamento_FormularioFiltroPesquisa"
                onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                }}
            >
                <div className="_mt-4 _mb-8">
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Número</label>
                        <input
                            disabled={props.processando}
                            type="text"
                            name="NumeroPedido"
                            id="PesquisaOrcamento_CampoFiltro_NumeroPedido"
                            autoFocus
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            value={formik.values.NumeroPedido ?? ''}
                            onChange={(event) => {
                                const numericValue = event.target.value.replace(/\D/g, '');
                                formik.handleChange({ target: { name: 'NumeroPedido', value: numericValue } });
                            }}
                        />
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Cliente</label>
                        <div className="_flex _items-center">
                            <input className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                                readOnly
                                disabled // sempre fica desabilitado
                                title="Clique na lupa para pesquisar o cliente"
                                placeholder="Clique na lupa para pesquisar"
                                id="PesquisaOrcamento_CampoFiltro_nomeCliente"
                                type="text" name="NomeCliente" value={formik.values.NomeCliente ?? ''}  
                            />
                            <div className="flex _gap-x-3"
                                id="PesquisaOrcamento_CampoFiltro_nomeCliente_Botoes"
                            >
                                <FontAwesomeIcon icon={faSearch} color="#3c8ac9" className="_text-2xl _mx-2" cursor={"pointer"}
                                    id="PesquisaOrcamento_CampoFiltro_nomeCliente_BotaoPesquisar"
                                    onClick={() => props.onPesquisarCliente(formik.values)} />
                                <FontAwesomeIcon icon={faXmarkCircle} color="#f25713" className="_text-2xl" cursor={"pointer"}
                                    id="PesquisaOrcamento_CampoFiltro_nomeCliente_BotaoLimpar"
                                    onClick={() => {
                                        formik.setFieldValue("NomeCliente", "")
                                        props.onLimparCliente()
                                    }} />
                            </div>

                        </div>
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Filial</label>
                        <select
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={props.processando}
                            id="PesquisaOrcamento_CampoFiltro_Filial"
                            multiple={false} name="CodigoFilial"
                            value={formik.values.CodigoFilial ?? ''}
                            onFocus={() => setCarregarOpcoesFilial(true)}
                            onMouseDown={() => setCarregarOpcoesFilial(true)}
                            onChange={(e) => formik.setFieldValue("CodigoFilial", e.target.value)}
                        >
                            <option value={""} id="PesquisaOrcamento_CampoFiltro_Filial_Vazio">Selecione</option>
                            {opcoesFilial.map((value) => (
                                <option key={value.Codigo} value={value.Codigo}
                                id={ `PesquisaOrcamento_CampoFiltro_Filial_${value.Codigo}`}
                                >
                                    {value.Descricao}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Vendedor</label>
                        <select
                            disabled={props.dadosPesquisaOrcamento?.Vendedores?.length <= 1 || props.processando}
                            id="PesquisaOrcamento_CampoFiltro_Vendedor"
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            name="CodigoVendedor"
                            value={formik.values.CodigoVendedor ?? ''}
                            onFocus={() => setCarregarOpcoesVendedor(true)}
                            onMouseDown={() => setCarregarOpcoesVendedor(true)}
                            onChange={(e) => formik.setFieldValue("CodigoVendedor", e.target.value)}
                        >
                            <option value={""} id={ `PesquisaOrcamento_CampoFiltro_Vendedor_Vazio`}>Selecione</option>
                            {opcoesVendedor.map((value) => (
                                <option key={value.CodigoVendedor} value={value.CodigoVendedor}
                                id={ `PesquisaOrcamento_CampoFiltro_Vendedor_${value.CodigoVendedor}`}
                                >
                                    {value.Nome}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Situação</label>
                        <select
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={props.processando}
                            id="PesquisaOrcamento_CampoFiltro_Situacao"
                            name="Situacao"
                            value={formik.values.Situacao ?? ''}
                            onChange={(e) => formik.setFieldValue("Situacao", e.target.value)}
                        >
                            <option value={""} id={ `PesquisaOrcamento_CampoFiltro_Situacao_Vazio`}>Selecione</option>
                            {props.dadosPesquisaOrcamento?.Situacoes?.map((value) => (
                                <option key={value.Codigo} value={value.Codigo}
                                    id={ `PesquisaOrcamento_CampoFiltro_Situacao_${value.Codigo}`}
                                >
                                    {value.Descricao}
                                </option>
                            ))}

                        </select>
                    </div>
                    {props.exibirSituacaoConferencia &&
                        <div className="_flex _my-2">
                            <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Situação Conferência</label>
                            <select
                                className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                                disabled={props.processando}
                                id="PesquisaOrcamento_CampoFiltro_SituacaoConferencia"
                                title="Veja parâmetros:&#013;-Utiliza código de barras na conferência de saídas?"
                                name="SituacaoConferencia"
                                value={formik.values.SituacaoConferencia ?? ''}
                                onChange={(e) => formik.setFieldValue("SituacaoConferencia", e.target.value)}
                            >
                                <option value={""} id={ `PesquisaOrcamento_CampoFiltro_SituacaoConferencia_Vazio`}>Selecione</option>
                                {props.dadosPesquisaOrcamento?.SituacaoConferencia?.map((value) => (
                                    <option key={value.Value} value={value.Value}
                                    id={ `PesquisaOrcamento_CampoFiltro_SituacaoConferencia_${value.Value}`}
                                    >
                                        {value.Description}
                                    </option>
                                ))}

                            </select>
                        </div>
                    }
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Inicial</label>
                        <InputData
                            id="PesquisaOrcamento_CampoFiltro_DataInicial"
                            key="PesquisaOrcamento_CampoFiltro_DataInicial"
                            disabled={props.processando}
                            className={`_w-[200px] ${estilosInputs.inputPadrao} ${formularioValidado && formik.errors.DataInicial != undefined && estilosInputs.inputComErro}`}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicial)}
                            onChange={(e) => formik.setFieldValue("DataInicial", e)}
                            selecionaValorOnFocus
                        />
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Final</label>
                        <InputData
                            id="PesquisaOrcamento_CampoFiltro_DataFinal"
                            key="PesquisaOrcamento_CampoFiltro_DataFinal"
                            disabled={props.processando}
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinal)}
                            onChange={(e) => formik.setFieldValue("DataFinal", e)}
                            selecionaValorOnFocus
                        />
                    </div>
                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Nº Pedido de Compra</label>
                        <input className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={formik.values.TipoOrcamento === 'TRA' || props.processando}
                            id="PesquisaOrcamento_CampoFiltro_NumeroPedidoCompra"
                            maxLength={15}
                            type="text" name="NumeroPedidoCompra" value={formik.values.NumeroPedidoCompra ?? ''}
                            onChange={formik.handleChange} />
                    </div>

                    <div ref={props.tableRef} />

                    <div className="_flex _my-2">
                        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Tipo de Orçamento</label>
                        <select
                            className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                            disabled={props.processando}
                            name="TipoOrcamento"
                            id="PesquisaOrcamento_CampoFiltro_ListaTiposOrcamento"
                            value={formik.values.TipoOrcamento ?? ''}
                            onChange={(e) => formik.setFieldValue("TipoOrcamento", e.target.value)}
                        >
                            {props.dadosPesquisaOrcamento?.ListaTiposOrcamento?.map((value) => (
                                <option key={value.Value} value={value.Value}
                                id={ `PesquisaOrcamento_CampoFiltro_ListaTiposOrcamento_${value.Value}`}
                                >
                                    {value.Description}
                                </option>
                            ))}
                        </select>
                    </div>

                    {props.vendedor != null && props.vendedor.UltimoPedido > 0 && !props.usuarioPedeSenhaACadaOrcamento && (
                        <>
                            <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Último Orçamento</label>
                            <span onClick={() => !props.processando && props.onEditarUltimoOrcamento()} 
                                className={`${props.processando ? '' : '_underline _cursor-pointer'}`}>{props.vendedor.UltimoPedido.toString()}</span>
                        </>
                    )}
                </div>


                <div>
                    <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                        type="submit"
                        id="PesquisaOrcamento_BotaoPesquisar"
                        title="Veja parâmetros:&#013;-Destacar orçamento com pendência de estoque na consulta de orçamentos&#013;-Exibir orçamentos unificados na consulta de orçamentos?&#013;-Pede senha a cada orþamento&#013;-Utiliza código de barras na conferência de saídas?&#013;-Habilitar duplicação de orçamento&#013;-Solicitar senha de liberação para troca de filial no orçamento?&#013;-Omitir valor total na pesquisa de orçamentos"
                        disabled={props.processando}
                    >Pesquisar</button>
                </div>
            </form>

            {props.dadosPesquisa?.PageMessage?.RowsCount >= 1 && <div>
                <Separador /> 
                
                {botoesAcaoTabela}

                {props.dadosPesquisa?.ValorTotalOrcamentos &&
                    <>
                        {props.dadosPesquisa?.PageMessage?.RowsCount > 1 
                            ? <div title="Veja parâmetro:&#013;-Omitir valor total na pesquisa de orçamentos"
                                    className="_my-4 _mx-3">{`Foram encontrados ${props.dadosPesquisa?.PageMessage?.RowsCount} registros`}</div> 
                            : <div title="Veja parâmetro:&#013;-Omitir valor total na pesquisa de orçamentos"
                                    className="_my-4 _mx-3">Foi encontrado 1 registro</div>
                        }
                    </>
                }

                <AcoesHeadPesquisaOrcamento
                    onToggleColunaSelecionada={props.onToggleColunaSelecionada}
                    onAlterarFonte={props.onAlterarFonte}
                    tamanhoFonte={props.tamanhoFontePadrao}
                    colunas={colunasOrdenadas}
                    onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
                    permiteEngrenagemGrid={props.permiteEngrenagemGrid ?? false}
                />

                <div className="_mb-4" style={{ overflow: "auto", fontSize: fonteGradeEmPxOuPadrao(props.tamanhoFontePadrao) }}>
                    <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}
                        id="PesquisaOrcamento_TabelaPedidos">

                        <HeadPesquisaOrcamento colunas={colunasOrdenadas} />

                        {props.dadosPesquisa?.PageMessage?.RowsCount >= 1 &&
                            <>
                                <tbody className="_table-row-group">
                                    {
                                        props.dadosPesquisa?.PageMessage?.Entities?.map((item) => (
                                            <tr key={item.NumeroPedido}
                                                id={`PesquisaOrcamento_Linha_${item.NumeroPedido}`}
                                                className="_table-row _cursor-pointer" 
                                                onClick={() => props.onSelecionarOrcamento(item)}
                                                style={item.NumeroPedido == props.orcamentoSelecionado?.NumeroPedido 
                                                    ? {
                                                        backgroundColor: props.corSelecionada,
                                                        color: props.textoSelecionado,
                                                        }
                                                    : {}
                                                }
                                            >
                                                {colunasOrdenadas.filter(c => c.Selecionada && c.Permitido).map((coluna) => (
                                                    itensOrcamento({
                                                        nomeColuna: coluna.Nome,
                                                        item: item
                                                    }))
                                                )}
                                            </tr>
                                        ))
                                    }
                                </tbody>

                                {props.dadosPesquisa?.ValorTotalOrcamentos &&

                                    <tfoot>
                                        {
                                            <tr className="_table-row">
                                                {colunasOrdenadas.filter(c => c.Selecionada && c.Permitido).map((coluna) => (
                                                    itensOrcamentoFooter({
                                                        nomeColuna: coluna.Nome, valorTotalOrcamentos: props.dadosPesquisa?.ValorTotalOrcamentos
                                                    }))
                                                )}
                                            </tr>
                                        }
                                    </tfoot>
                                }

                            </>
                        }
                    </table>
                </div>

                {props.dadosPesquisa?.PageMessage?.PageCount > 1 &&
                    <Paginacao
                        id="PesquisaOrcamento_Paginacao"
                        key={props.dadosPesquisa?.PageMessage?.ActualPage}
                        paginaAtual={props.dadosPesquisa?.PageMessage?.ActualPage}
                        totalPaginas={props.dadosPesquisa?.PageMessage?.PageCount}
                        desabilitarPaginacao={props.processando} // 456986
                        onAlterarListaSelecionada={(pagina) =>
                            props.onPesquisarPaginada({ ...formik.values, NumeroPagina: pagina })}
                    />
                }

                {props.dadosPesquisa?.PageMessage?.RowsCount > 1 &&
                    botoesAcaoTabela}

                <div className="_my-4">
                    <Legenda itens={itensLegendas} />
                </div>
            </div>}
            {<section style={{ marginBottom: "100px" }} />}
        </>
    )
})
